import React, { useState } from "react";

// React Router Dom
import { useNavigate } from "react-router-dom";

// Supabase
import { supabase } from "../../supabase";

// Hooks
import useSnackbarNotification from "../../hooks/useSnackbarNotification";

const ResetPassword = () => {
    const navigate = useNavigate();
    const { showError, showSuccess } = useSnackbarNotification();
    
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (password !== confirmPassword) {
            showError("Passwords do not match");
            setLoading(false);
            return;
        }

        try {
            const { error } = await supabase.auth.updateUser({
                password: password,
            });

            if (error) throw error;

            showSuccess("Password has been reset successfully!");
            navigate("/login");
        } catch (error) {
            showError(
                error.message ||
                    "An error occurred while resetting your password"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex">
            <div className="hidden md:flex md:w-1/2 bg-gray-50 flex-col space-y-6 overflow-auto">
                <img
                    src="/login.jpg"
                    alt="Reset Password"
                    className="w-full h-full object-cover"
                />
            </div>

            <div className="w-full md:w-1/2 bg-gray-50 flex flex-col justify-center px-8 md:px-20">
                <div className="max-w-md w-full mx-auto">
                    
                    <div
                        className="logo cursor-pointer justify-center mb-8"
                        onClick={() => navigate("/")}
                    >
                        Doctors' Jobs <span className="logo-badge">Beta</span>
                    </div>

                    <h2 className="text-2xl font-bold text-black text-center mb-8">
                        Reset Password
                    </h2>
                    <p className="text-sm text-black text-center mb-8">
                        Please enter your new password below.
                    </p>

                    <form className="space-y-6" onSubmit={handleSubmit}>
                        <div>
                            <label
                                htmlFor="password"
                                className="block text-base md:text-lg font-medium text-gray-700 mb-1"
                            >
                                New Password *
                            </label>
                            <input
                                id="password"
                                name="password"
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="confirmPassword"
                                className="block text-base md:text-lg font-medium text-gray-700 mb-1"
                            >
                                Confirm New Password *
                            </label>
                            <input
                                id="confirmPassword"
                                name="confirmPassword"
                                type="password"
                                required
                                value={confirmPassword}
                                onChange={(e) =>
                                    setConfirmPassword(e.target.value)
                                }
                                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                        </div>

                        <div>
                            <button
                                type="submit"
                                disabled={loading}
                                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-black hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:opacity-50"
                            >
                                {loading ? "Resetting..." : "Reset Password"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
